import pImg1 from '@images/apartment/apartment1.webp'
import pImg2 from '@images/apartment/apartment2.webp'
import pImg3 from '@images/apartment/apartment3.webp'
import pImg4 from '@images/apartment/apartment4.webp'
import pImg5 from '@images/apartment/apartment5.webp'
import pImg6 from '@images/apartment/apartment6.webp'
import pImg7 from '@images/apartment/apartment7.webp'
import pImg8 from '@images/apartment/apartment8.webp'
import pImg9 from '@images/apartment/apartment9.webp'
import pImg10 from '@images/apartment/apartment10.webp'
import pImg11 from '@images/apartment/apartment11.webp'
import pImg12 from '@images/apartment/apartment12.webp'
import pImg13 from '@images/apartment/apartment13.webp'
import pImg14 from '@images/apartment/apartment14.webp'
import pImg15 from '@images/apartment/apartment15.webp'
import pImg16 from '@images/apartment/apartment16.webp'
import pImg17 from '@images/apartment/apartment17.webp'
import pImg18 from '@images/apartment/apartment18.webp'


import pSImg1 from '@images/apartment/apartment1.webp'
import pSImg2 from '@images/apartment/apartment2.webp'
import pSImg3 from '@images/apartment/apartment3.webp'

import sIcon1 from '@images/apartment/icon1.webp'
import sIcon2 from '@images/apartment/icon2.webp'
import sIcon3 from '@images/apartment/icon3.webp'

import ProjectSinglePage01 from './01'
import ProjectSinglePage02 from './02'
import ProjectSinglePage03 from './03'
import ProjectSinglePage04 from './04'
import ProjectSinglePage05 from './05'
import ProjectSinglePage06 from './06'
import ProjectSinglePage07 from './07'
import ProjectSinglePage08 from './08'
import ProjectSinglePage09 from './09'
import ProjectSinglePage10 from './10'
import ProjectSinglePage11 from './11'
import ProjectSinglePage12 from './12'
import ProjectSinglePage13 from './13'
import ProjectSinglePage14 from './14'
import ProjectSinglePage15 from './15'
import ProjectSinglePage16 from './16'
import ProjectSinglePage17 from './17'
import ProjectSinglePage18 from './18'
import React from 'react'

const Projects = [
    {
        Id: '1',
        pTitle: 'Projekt 1', 
        slug: 'Deska podłogowa',
        pImg:pImg1,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        content:(<ProjectSinglePage01 />)
    },
    {
        Id: '2',
        pTitle: 'Projekt 2', 
        slug: 'Schody drewniane',
        pImg:pImg2,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        content:(<ProjectSinglePage02 />)
    },
    {
        Id: '3',
        pTitle: 'Projekt 3', 
        slug: 'Podłoga drewniana',
        pImg:pImg3,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage03 />)
    },
    {
        Id: '4',
        pTitle: 'Projekt 4', 
        slug: 'Podłoga drewniana 4',
        pImg:pImg4,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage04 />)
    },
    {
        Id: '5',
        pTitle: 'Projekt 5', 
        slug: 'Podłoga drewniana 5',
        pImg:pImg5,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage05 />)
    },
    {
        Id: '6',
        pTitle: 'Projekt 6', 
        slug: 'Deska podłogowa 6',
        pImg:pImg6,
        pSImg:pSImg1,
        ssIcon:sIcon1,
        content:(<ProjectSinglePage06 />)
    },
    {
        Id: '7',
        pTitle: 'Projekt 7', 
        slug: 'Schody drewniane 7',
        pImg:pImg7,
        pSImg:pSImg2,
        ssIcon:sIcon2,
        content:(<ProjectSinglePage07 />)
    },
    {
        Id: '8',
        pTitle: 'Projekt 8', 
        slug: 'Podłoga drewniana 8',
        pImg:pImg8,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage08 />)
    },
    {
        Id: '9',
        pTitle: 'Projekt 9', 
        slug: 'Podłoga drewniana 9',
        pImg:pImg9,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage09 />)
    },
    {
        Id: '10',
        pTitle: 'Projekt 10', 
        slug: 'Podłoga drewniana 10',
        pImg:pImg10,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage10 />)
    },
    {
        Id: '11',
        pTitle: 'Projekt 11', 
        slug: 'Podłoga drewniana 11',
        pImg:pImg11,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage11 />)
    },
    {
        Id: '12',
        pTitle: 'Projekt 12', 
        slug: 'Podłoga drewniana 12',
        pImg:pImg12,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage12 />)
    },
    {
        Id: '13',
        pTitle: 'Projekt 13', 
        slug: 'Podłoga drewniana 13',
        pImg:pImg13,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage13 />)
    },
    {
        Id: '14',
        pTitle: 'Projekt 14', 
        slug: 'Podłoga drewniana 14',
        pImg:pImg14,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage14 />)
    },
    {
        Id: '15',
        pTitle: 'Projekt 15', 
        slug: 'Podłoga drewniana 15',
        pImg:pImg15,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage15 />)
    },
    {
        Id: '16',
        pTitle: 'Inne realizacje', 
        slug: 'Podłoga drewniana 16',
        pImg:pImg16,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage16 />)
    },
    {
        Id: '17',
        pTitle: 'Oświetlenie led', 
        slug: 'Podłoga drewniana 17',
        pImg:pImg17,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage17 />)
    },
    {
        Id: '18',
        pTitle: 'Balustrady', 
        slug: 'Podłoga drewniana 18',
        pImg:pImg18,
        pSImg:pSImg3,
        ssIcon:sIcon3,
        content:(<ProjectSinglePage18 />)
    }
]

export default Projects;